export enum Duration {
  TODAY = 'today',
  WEEK = 'week',
  MONTH = 'month',
}
